import React from 'react';
import classNames from 'classnames';
import { addressFormatter, optionClassFormatter } from '../../../utils/formatters';
import {
  ActionsFormatter,
  battery1VoltageFormatter,
  battery2VoltageFormatter,
  lowerDoorFormatter, MobileMoreFormatter,
  powerSupplyFormatter,
  StatusFormatterWithProblem,
  upperDoorFormatter,
  WorkingStateFormatter,
} from './ParkingFormatters';
import { Icons } from '../../../components/base/BootstrapComponents';

export default function MobileParkingMeterItem(props) {
  const { showOnMap = () => {}, item, handleClose } = props;
  if (!item) {
    return null;
  }
  return (
    <div className="mpm-host-block">
      <div className={classNames('mpm-host', optionClassFormatter(item.status))}>
        {item.type && Number(item.type) === 1 ? 'Паркомат' : 'Видеокамера' } {item.host}
        {handleClose ? <Icons icon="close" customIcon className="close" onClick={handleClose} /> : null}
      </div>
      <div className="mpm-info mpm-address">
        <div className="mpm-label">Адрес</div>
        {addressFormatter(item.zbx_address, true, item.zbx_zone, true, () => showOnMap(item))}
      </div>
      <div className="mpm-info mpm-working-state">
        <div className="mpm-label">Работа устройства</div>
        <WorkingStateFormatter item={item} />
      </div>
      <div className="mpm-info state-and-door with-sub">
        <div className="mpm-info-sub mpm-status">
          <div className="mpm-label">Состояние</div>
          <StatusFormatterWithProblem item={item} />
        </div>
        <div className="mpm-info-sub mpm-low-door">
          <div className="mpm-label">Нижняя дверь</div>
          {lowerDoorFormatter(item, item)}
        </div>
        <div className="mpm-info-sub mpm-up-door">
          <div className="mpm-label">Верхняя дверь</div>
          {upperDoorFormatter(item, item)}
        </div>
      </div>
      <div className="mpm-info mpf-voltage-state with-sub">
        <div className="mpm-info-sub">
          <div className="mpm-label">Напряж-е <br />1 АКБ</div>
          {battery1VoltageFormatter(item, item)}
        </div>
        <div className="mpm-info-sub">
          <div className="mpm-label">Напряж-е <br /> 2 АКБ</div>
          {battery2VoltageFormatter(item, item)}
        </div>
        <div className="mpm-info-sub power-supply">
          <div className="mpm-label">Питание</div>
          {powerSupplyFormatter(item, item)}
        </div>
      </div>
      <div className="mpm-info mpf-buttons">
        <ActionsFormatter item={item} />
        <MobileMoreFormatter item={item} />
      </div>
    </div>
  );
}
